module.exports = __webpack_public_path__ + "img/jianshe.4a1c8791.png";